import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../scrapers.component';

@Component({
  selector: 'app-s3-dialog',
  templateUrl: './s3-dialog.component.html',
  styleUrls: ['./s3-dialog.component.scss']
})
export class S3DialogComponent implements OnInit {

  s3Params;

  constructor(
    public dialogRef: MatDialogRef<S3DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {

    this.s3Params = {
      limit: 50,
    };
  }

  cancel(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

}
